import { render, staticRenderFns } from "./FormP8.vue?vue&type=template&id=22dc73d8&scoped=true"
import script from "./FormP8.vue?vue&type=script&lang=ts"
export * from "./FormP8.vue?vue&type=script&lang=ts"
import style0 from "./FormP8.vue?vue&type=style&index=0&id=22dc73d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc73d8",
  null
  
)

export default component.exports